module.exports = __webpack_public_path__ + "static/construction_services-b511d3a7cf331b97fb7ce969c8be1ee6.jpg";